__turbopack_context__.v({
  "className": "inter_4e0bcd13-module__eLfRjq__className",
  "variable": "inter_4e0bcd13-module__eLfRjq__variable",
});
